import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CreateManagementReportRequestDto } from '@domain/management-report/dtos/create-management-report.request.dto';
import { ListManagementReportRequestDto } from '@domain/management-report/dtos/list-management-report.request.dto';
import { ManagementReportColumnCatalogResponseDto } from '@domain/management-report/dtos/management-report-column-catalog.response.dto';
import { ManagementReportSummaryResponseDto } from '@domain/management-report/dtos/management-report-summary.response.dto';
import { ManagementReportResponseDto } from '@domain/management-report/dtos/management-report.response.dto';
import { UpdateManagementReportRequestDto } from '@domain/management-report/dtos/update-management-report.request.dto';

@Injectable({
  providedIn: 'root',
})
export class ManagementReportService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('management/report');
  }

  list(request: ListManagementReportRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<ManagementReportResponseDto>>
    >(queryUrl, { params: { ...request } });
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<ManagementReportResponseDto>>(queryUrl);
  }

  create(request: CreateManagementReportRequestDto) {
    const queryUrl = this.getApiUrl();
    return this.http.post<ApiResponse<ManagementReportResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(request: UpdateManagementReportRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<ManagementReportResponseDto>>(
      queryUrl,
      request,
    );
  }

  delete(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.delete<ApiResponse<void>>(queryUrl);
  }

  summary() {
    const queryUrl = `${this.getApiUrl()}/summary`;
    return this.http.get<ApiResponse<ManagementReportSummaryResponseDto>>(
      queryUrl,
    );
  }

  getColumnCatalog(entityType: string) {
    const queryUrl = `${this.getApiUrl()}/column-catalog`;
    return this.http.get<ApiResponse<ManagementReportColumnCatalogResponseDto>>(
      queryUrl,
      { params: { entityType } },
    );
  }

  duplicate(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/${request.refId}/duplicate`;
    return this.http.post<ApiResponse<ManagementReportResponseDto>>(
      queryUrl,
      {},
    );
  }
}
